import { useEffect, useState } from 'react';
import '../App.scss';
import { Button } from '@mui/base/Button';
import { useNavigate } from 'react-router-dom';

import { ProjectWithResponse, ProjectStatus, ResponseClient, ProjectDetailModel } from '../types';
import { createClient } from '../api/clients';
import { APIPATH } from '../App';

function ProjectsPage() {
  const navigate = useNavigate();

  const [projects, setProjects] = useState<ProjectWithResponse[]>([]);
  const [projectsLeft, setProjectsLeft] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [isLead, setIsLead] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const responseClient = createClient(ResponseClient);

  useEffect(() => {
    fetchPermissions();
    fetchProjects();
  }, []);

    const fetchPermissions = async () => {
    try {
      const res = await fetch(APIPATH + "/Auth/currentUser", {
        credentials: "include"
      });

      if (res.status === 401) {
        navigate("/login");
        return;
      }

      const data = await res.json();
      setIsLead(data.isLead);
      if (data.isAdmin === true) {
        navigate("/project-admin")
      }

    } catch (err) {
      console.error("Error fetching permissions:", err);
    }
  };

 
  const fetchProjects = async () => {
    setLoading(true);
    setErrorMessage(null);

    try {
      const result = await responseClient.getProjects();
      setProjects(result?.projects ?? []); 
      setProjectsLeft(result?.projectsLeft ?? 0);
    } catch (err) {
      console.error('Error fetching projects:', err);
      setErrorMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    navigate('/onboarding');
  };

  const handleEdit = (id?: string) => {
    if (!id) return;
    navigate(`/project/?p=${id}`);
  };

    const handleReport = (id?: string) => {
    if (!id) return;
    navigate(`/report/?r=${id}`);
  };

  const handleGoToTeamManagement = () => navigate('/team-management');

return (
        <div className="main container py-4 mb-6">
            <div
                className="pb-4 mb-4"
                style={{ width: '100%', maxWidth: '700px', margin: '0 auto' }}
            >

               
                <div className="d-flex gap-2" style={{ marginBottom: "3em" }}>
                    {isLead && (
                    <Button className="styled-button" onClick={handleGoToTeamManagement} id="btn-team-management">
                    Team management
                    </Button>)}

                      {projectsLeft > 0 && (
                  <Button className="styled-button" onClick={handleCreate} id="btn-create-project">
                      Create project
                  </Button>
                )}
                </div>

                <div className="d-flex justify-content-between align-items-center mb-3">
                <h2 className="mb-0">Projects</h2>
              
                </div>

                <p className="mb-3">
                View and manage your projects. Your organisation has {projectsLeft} projects left
                </p>

                {loading && <p>Loading projects…</p>}

                {errorMessage && !loading && (
                <div className="form-error mb-3">
                    {errorMessage}
                </div>
                )}

                {!loading && !errorMessage && (
                <>
                    {projects.length === 0 ? (
                    <p>No projects found.</p>
                    ) : (
                    <div style={{ width: '100%' }}>
                        <table className="table" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                            <th style={{ textAlign: 'left' }}>Project name</th>
                            <th style={{ textAlign: 'right' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projects.map((project) => (
                            <tr key={project._id}>
                                <td>{project.projectTitle ?? '(Untitled project)'}</td>
                                
                               <td style={{ textAlign: 'right' }}>
                                {project.status === ProjectStatus.AwaitingAdminApproval ? (
                                  <Button
                                    className="styled-button"
                                    disabled
                                    style={{ opacity: 0.5, cursor: 'not-allowed' }}
                                  >
                                    Submitted
                                  </Button>
                                ) : project.status === ProjectStatus.Complete ? (
                                  <Button
                                    className="styled-button"
                                    onClick={() => handleReport(project.response?.[0]?._id)}
                                  >
                                    View report
                                  </Button>
                                ) : (
                                  <Button
                                    className="styled-button"
                                    onClick={() => handleEdit(project._id)}
                                  >
                                    Edit
                                  </Button>
                                )}
                              </td>
                            </tr>
                            ))}
                        </tbody>
                        </table>
                    </div>
                    )}
                </>
                )}
            </div>
        </div>

);

}

export default ProjectsPage;
